import { I18n } from 'src/translations/i18n';
import { toastr } from 'react-redux-toastr';
import communicate from 'src/api/communicate';
import toastrError from 'src/helpers/toastr/toastrError';
import Utils from 'src/utils';
import { loadExcelExport } from 'src/store/actions/excelActions';
export var TableHistoryActions;
(function (TableHistoryActions) {
    TableHistoryActions["GET_TABLE_HISTORY_REQUEST"] = "GET_TABLE_HISTORY_REQUEST";
    TableHistoryActions["GET_TABLE_HISTORY_SUCCESS"] = "GET_TABLE_HISTORY_SUCCESS";
    TableHistoryActions["GET_TABLE_HISTORY_FAIL"] = "GET_TABLE_HISTORY_FAIL";
    TableHistoryActions["GET_TABLE_HISTORY_CONFIG_SUCCESS"] = "GET_TABLE_HISTORY_CONFIG_SUCCESS";
})(TableHistoryActions || (TableHistoryActions = {}));
function getTableHistoryRequest() {
    return { type: TableHistoryActions.GET_TABLE_HISTORY_REQUEST };
}
function getTableHistorySuccess(payload) {
    return { type: TableHistoryActions.GET_TABLE_HISTORY_SUCCESS, payload };
}
function getTableHistoryFail() {
    return { type: TableHistoryActions.GET_TABLE_HISTORY_FAIL };
}
function getTableHistoryConfigSuccess(payload) {
    return { type: TableHistoryActions.GET_TABLE_HISTORY_CONFIG_SUCCESS, payload };
}
export function getTableHistory(params) {
    return (dispatch) => {
        dispatch(getTableHistoryRequest());
        return communicate({ url: 'v2/TableHistory/Search', method: 'post', data: params })
            .then(({ data }) => {
            dispatch(getTableHistorySuccess(data));
            if (!data?.Data?.length) {
                toastr.warning(I18n.t('NoDataAvailable'), '');
            }
        })
            .catch((error) => {
            console.error(error);
            dispatch(getTableHistoryFail());
            toastrError(error);
        });
    };
}
export function loadExcel(params) {
    return (dispatch) => {
        const request = {
            url: 'v2/TableHistory/Excel',
            query: Utils.objects.getQueryStringFromObject(params)
        };
        return dispatch(loadExcelExport(request));
    };
}
export function getTableHistoryConfig() {
    return (dispatch) => {
        return fetch(`/config.json?timestamp=${new Date().getTime()}`)
            .then((res) => res.json())
            .then((data) => {
            dispatch(getTableHistoryConfigSuccess(data));
        })
            .catch(() => {
            console.warn('Failed to load events history config from public config.json file.');
        });
    };
}
